module.exports = __webpack_public_path__ + "img/zh.7f63ceb3.png";